import "./VideoButton.scss";
import { FC, useState } from "react";
import { createPortal } from "react-dom";
import { VscChromeClose } from "react-icons/vsc";
import Button from "../Button";
import { trackEvent } from "../../../../lib/analytics";
import CarEntity from "../../../../domain/entities/CarEntity";

// Acepta watch?v=, youtu.be/, /embed/, /shorts/ y /live/. Devuelve null si no es un link de YouTube valido.
const youtubeEmbedUrl = (url?: string | null) => {
    const id = url?.match(
        /(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/))([\w-]{11})/,
    )?.[1];
    return id ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0` : null;
};

// Pantalla con play (Figma 5659-8968).
const VideoIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <rect x="4" y="5" width="24" height="17" rx="1" />
        <path d="M2 27h28" strokeLinecap="round" />
        <path d="M13.5 9.5v8l6.5-4z" strokeLinejoin="round" />
    </svg>
);

// Boton + modal del video de YouTube del vehiculo. No renderiza nada si no hay link valido.
const VideoButton: FC<{ car: CarEntity }> = ({ car }) => {
    const [open, setOpen] = useState(false);
    const embed = youtubeEmbedUrl(car.videoUrl);
    if (!embed) return null;

    return (
        <>
            <Button
                className="btn-video"
                variant="secondary"
                label="VER VIDEO"
                iconRight={<VideoIcon />}
                onClick={() => {
                    trackEvent("vehiculo_video_abierto", { vehiculo_id: String(car.id) });
                    setOpen(true);
                }}
            />
            {open &&
                // Portal al body: evita que contenedores con transform/overflow recorten el overlay fijo.
                createPortal(
                    <div
                        onClick={() => setOpen(false)}
                        style={{
                            position: "fixed",
                            inset: 0,
                            zIndex: 1000000000000,
                            backgroundColor: "rgba(0,0,0,0.85)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <div
                            aria-label="Cerrar video"
                            onClick={() => setOpen(false)}
                            style={{
                                position: "absolute",
                                top: 16,
                                right: 16,
                                width: 50,
                                height: 50,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                color: "#fff",
                                fontSize: 40,
                                backgroundColor: "rgba(0,0,0,0.2)",
                            }}
                        >
                            <VscChromeClose />
                        </div>
                        <iframe
                            src={embed}
                            title={`Video de ${car.name}`}
                            allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
                            allowFullScreen
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                // Lo mas grande posible sin pasarse del ancho ni del alto de la pantalla.
                                width: "min(96vw, calc(85vh * 16 / 9), 1400px)",
                                aspectRatio: "16 / 9",
                                border: 0,
                                borderRadius: 12,
                            }}
                        />
                    </div>,
                    document.body,
                )}
        </>
    );
};

export default VideoButton;
